<div class="edit-container">
    <h1 class="edit-title">Actualizare șablon cerere</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <!-- Basic Information Section -->
        <div class="card mb-3">
            <div class="card-header">
                <h4 class="card-title mb-0">
                    <i class="fas fa-info-circle me-2"></i>
                    Informații de Bază
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Nume</mat-label>
                            <input type="text" matInput formControlName="name" />
                            <mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <!-- Organization and Category Section -->
        <div class="card mb-3">
            <div class="card-header">
                <h4 class="card-title mb-0">
                    <i class="fas fa-tags me-2"></i>
                    Organizare și Categorizare
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Direcție</mat-label>
                            <mat-select formControlName="directie_id" (openedChange)="onDirectieSelectClosed()"
                                (selectionChange)="onDirectieChange($event.value)">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="!form.controls['directie_id'].valid && form.controls['directie_id'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Compartiment</mat-label>
                            <mat-select formControlName="compartiment_id" (openedChange)="onCompartimentSelectClosed()"
                                (selectionChange)="onCompartimentChange()">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="compartimenteControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>

                                <mat-option *ngFor="let compartiment of filteredCompartimente"
                                    [value]="compartiment.id">
                                    {{ compartiment.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Categoria Primară (opțional)</mat-label>
                            <mat-select formControlName="primary_category_id">
                                <mat-option *ngFor="let category of availableCategories" [value]="category.id">
                                    {{ category.name }}
                                    <span *ngIf="category.description" class="text-muted"> - {{ category.description
                                        }}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <!-- Content Section -->
        <div class="card mb-3">
            <div class="card-header">
                <h4 class="card-title mb-0">
                    <i class="fas fa-edit me-2"></i>
                    Conținut Șablon
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <angular-editor formControlName="content" [config]="editorConfig"></angular-editor>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>